// @moods/ui copy for the brand + nav components. tr and en must have identical keys.
// Turkish is the design-system source copy (sentence case, no exclamation marks); English is a natural translation.
// Turkish part; nav.en.ts must have the same keys.
const dict: Record<string, string> = {
  'brand.name': 'MOODS',
  'brand.appIcon': 'MOODS uygulama simgesi',

  'nav.rail.label': 'Topluluklar',
  'nav.rail.home': 'MOODS Ana Sayfa',
  'nav.rail.messages': 'Mesajlar',
  'nav.rail.add': 'Topluluk ekle',
  'nav.rail.discover': 'Keşfet',
  'nav.rail.admin': 'Yönetim paneli',
  'nav.rail.unread': 'okunmamış mesajlar var',
  'nav.rail.mentions': '{count} bahsedilme',
  'nav.rail.inVoice': 'buradaki bir ses kanalındasın',
  'nav.rail.moved': '{name}, {position}. sıraya taşındı',
  'nav.rail.movedInFolder': '{name}, {folder} klasöründe {position}. sıraya taşındı',
  'nav.rail.folder': 'Klasör: {name}',
  'nav.rail.folderCount': 'Topluluk sayısı: {count}',
  'nav.rail.folderMore': '+{count} topluluk daha',

  'nav.count.members': '{count} üye',
  'nav.count.online': '{count} çevrimiçi',

  'nav.community.menu': 'Topluluk menüsü',
  'nav.category.add': 'Kanal oluştur',

  'nav.channel.invite': 'Davet et',
  'nav.channel.settings': 'Kanal ayarları',
  'nav.channel.unread': 'okunmamış',
  'nav.channel.mentions': '{count} bahsedilme',
  'nav.channel.muted': 'sessize alındı',
  'nav.channel.type.voice': 'ses kanalı',
  'nav.channel.type.forum': 'forum kanalı',
  'nav.channel.type.announcement': 'duyuru kanalı',
  'nav.channel.type.stage': 'sahne kanalı',
  'nav.channel.type.private': 'özel kanal',

  'nav.voice.participants': '{channel} katılımcıları',
  'nav.voice.you': '(sen)',

  'nav.dock.label': 'Kullanıcı kontrolleri',
  'nav.dock.status': '{name}, durumunu değiştir',
  'nav.dock.mute': 'Mikrofonu kapat',
  'nav.dock.deafen': 'Sağırlaştır',
  'nav.dock.settings': 'Kullanıcı ayarları',

  'nav.topbar.threads': 'Akışlar',
  'nav.topbar.notifications': 'Bildirim ayarları',
  'nav.topbar.pinned': 'Sabitlenmiş mesajlar',
  'nav.topbar.members': 'Üye listesi',
  'nav.topbar.search': 'Ara',
  'nav.topbar.inbox': 'Gelen kutusu',
  'nav.topbar.inboxUnread': 'Gelen kutusu, yeni bildirimler var',
  'nav.topbar.help': 'Yardım',

  'nav.titlebar.back': 'Geri',
  'nav.titlebar.forward': 'İleri',
  'nav.titlebar.search': 'Ara veya komut çalıştır',
  'nav.titlebar.update': 'Güncelleme hazır',
  'nav.titlebar.minimize': 'Küçült',
  'nav.titlebar.maximize': 'Büyüt',
  'nav.titlebar.restore': 'Önceki boyut',
  'nav.titlebar.close': 'Kapat',
};

export default dict;
